module.exports = __webpack_public_path__ + "img/personal_image.ec38ac7f.svg";